module.exports = __webpack_public_path__ + "img/activity_vip.7f4a7c40.png";